import type { ExternalProductType } from '@shared/products-types';

import type { AliasChangeStrategyShape } from '../types/aliasChange';
import type { ActionsDropdownConfig, ProductConfiguration } from './productConfigurationRegistry';
import { registerAliasChangeStrategy } from '../services/changeAliasService';
import { setProductConfiguration } from './productConfigurationRegistry';

export type ProductConfigurationWithAlias<T> = {
    aliasChangeStrategy: AliasChangeStrategyShape;
} & ProductConfiguration<T>;

export type { ActionsDropdownConfig };

export const registerProductType = <T>(
    type: ExternalProductType | string,
    configuration: ProductConfigurationWithAlias<T>,
): void => {
    setProductConfiguration(type, {
        dataSelector: configuration.dataSelector,
        dataSelectorId: configuration.dataSelectorId,
        queryAllIfNeeded: configuration.queryAllIfNeeded,
        productStrategy: configuration.productStrategy,
        queryAll: configuration.queryAll,
        actionsDropdown: configuration.actionsDropdown,
    });
    registerAliasChangeStrategy(type, configuration.aliasChangeStrategy);
};
